export default __webpack_public_path__ + "static/media/allOn_ru_d.e2a55981.svg";